export default __webpack_public_path__ + "static/media/119.91bd3cdc.jpg";